module.exports = __webpack_public_path__ + "static/img/pin-spray-request-scheduled.f45d4be.svg";